import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) { toast.error("Le password non coincidono"); return; }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Password aggiornata. Ora puoi accedere.");
      nav("/login");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Token non valido o scaduto");
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-md mx-auto px-5 py-16">
      <div className="text-xs tracking-widest uppercase text-primary">Reimposta password</div>
      <h1 className="font-display text-3xl mt-2">Nuova password</h1>
      {!token ? (
        <div className="mt-6 bg-white border border-border rounded-xl p-6">
          <p className="text-sm text-foreground/70">Link non valido. <Link to="/password-dimenticata" className="text-primary">Richiedi un nuovo link</Link>.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="mt-6 bg-white border border-border rounded-xl p-6 space-y-4">
          <div>
            <Label htmlFor="pw">Nuova password (min. 6 caratteri)</Label>
            <Input id="pw" type="password" required minLength={6} value={pw} onChange={(e)=>setPw(e.target.value)} className="mt-1" data-testid="reset-pw" />
          </div>
          <div>
            <Label htmlFor="pw2">Conferma password</Label>
            <Input id="pw2" type="password" required minLength={6} value={pw2} onChange={(e)=>setPw2(e.target.value)} className="mt-1" data-testid="reset-pw2" />
          </div>
          <Button type="submit" disabled={busy} className="w-full rounded-full h-11" data-testid="reset-submit">
            {busy ? "Salvataggio..." : "Aggiorna password"}
          </Button>
        </form>
      )}
    </div>
  );
}
